import React from 'react';
import Campaigns from '../../components/Campaigns';
import PageLayout from '../../ui/layout/PageLayout';
import './styles.css';

function CampaignsPage() {
  return (
    <PageLayout title="Campanhas" subtitle="Criação e acompanhamento" primary={<Campaigns />} secondary={null} />
  );
}

export default CampaignsPage;
